import { DefaultTheme } from "styled-components";
export const defaultTheme: DefaultTheme = {
  borderRadius: "4px",
  colors: {
    primary: "#5C63DE",
    secondary: "#5C63DE",
    light: "#edecfb",
    lightGray: "#EFF0F7",
    error: "#FF0000",
  },
};
